// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'
import { IdMap } from '@/legacy/types/api/store'
import { Entity } from '@/legacy/types/entities/entities'
import { idMapTransform } from '@/libs/format/objects'

export const useEntitiesApi = apiStore<Entity, IdMap<Entity>>(
  'entitiesApi',
  '/api/entities',
  {
    transformData: (d: { data: Entity[] }) =>
      idMapTransform({}, 'data', 'entityId', d.data),
  }
)
